import { useState } from "react";

export type SchedulerMode = "create" | "edit" | "upload";
export type SchedulerContext = "global" | "client";

export interface SchedulerState {
  open: boolean;
  mode: SchedulerMode;
  initialData: any | null;
  context?: SchedulerContext;
}

const DEFAULT_SCHEDULER_STATE: SchedulerState = {
  open: false,
  mode: "create",
  initialData: null,
  context: "global",
};

export function useSchedulerState() {
  const [schedulerState, setSchedulerState] = useState<SchedulerState>(DEFAULT_SCHEDULER_STATE);

  const closeScheduler = () =>
    setSchedulerState((prev) => ({ ...prev, open: false }));

  return { schedulerState, setSchedulerState, closeScheduler };
}
